const requesterFields = ['name', 'phoneNumber'];
const relatedFields = [
    'objectAsset',
    'objectLocationForWorkOrder',
    'userAssignedTo',
    'objectProject',
];

const generateDescription = (request, formItems) => {
    let theDescription = `${request.note}
Name: ${request.name || ''}
Email Address: ${request.requesterEmailAddress}
Phone Number: ${request.phoneNumber || ''}
`;

    for (let i = 0; i < formItems.length; i++) {
        let tempFormItem = formItems[i];
        tempFormItem._value = tempFormItem._value  || '';
        theDescription += `\n ${tempFormItem.formName}: ${tempFormItem._value}`;
    }

    return theDescription;
};

export const getWORequests = (roleId, email, statusFilter) => {
    let body = {
            roleId,
            requesterEmailAddress: email,
            statusCounts: true
        };
    if (statusFilter) {
        body.status = statusFilter;
    }
    return fetch(`${process.env.REACT_APP_API_URL}/api/app/search/requested-work-orders`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    })
        .then(resp => resp.json())
        .then(resp => ({ results: resp.results, counts: resp.counts }))
        .catch(console.error);
};

export const createWORequest = (roleId, data, formItems = []) => {
    // transform data
    data.note = generateDescription(data, formItems);
    data.categoryType = data.categoryType
        ? data.categoryType.value : undefined;
    requesterFields.forEach(field => {
        delete data[field];
    });

    // only send the ids to the server for related fields
    relatedFields.forEach(field => {
        data[field] = (data[field] && data[field].id)
            ? data[field].id : undefined;
    });

    return fetch(`${process.env.REACT_APP_API_URL}/api/app/create/work-order-request`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            ...data
        })
    })
        .then(resp => resp.json())
        .then(resp => {
            if (resp.success) {
                return resp.result;
            }
            throw resp.message;
        });
};
